import HttpRequest from './axios/fetch.axios'
export default new HttpRequest()
